interface IErrorPayload {
  message?: string;
  messageCode?: string;
  reasons?: string[];
  errors?: Record<string, unknown>;
  recoverable_until?: string | null;
  detail?: string;
  invitation_id?: number;
  invited_user_type?: unknown;
  invitation_type?: unknown;
  data?: unknown;
}

export class NetworkError {
  public code: number;
  public description: string;
  public errorPayload: IErrorPayload;

  constructor(code: number, description: string, errorPayload: IErrorPayload) {
    this.code = code;
    this.description = description;
    this.errorPayload = errorPayload;
  }
}
